import script from "./PublicationViewer.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicationViewer.vue?vue&type=script&setup=true&lang=js"

import "./PublicationViewer.vue?vue&type=style&index=0&id=2971fd6f&lang=css"

const __exports__ = script;

export default __exports__